import { render, staticRenderFns } from "./music_set.vue?vue&type=template&id=a8bf741a"
import script from "./music_set.vue?vue&type=script&lang=js"
export * from "./music_set.vue?vue&type=script&lang=js"
import style0 from "./music_set.vue?vue&type=style&index=0&id=a8bf741a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports